import axios from 'axios'
import qs from 'qs'

// axios 配置
// axios.defaults.baseURL = 'http://atoshi.talkingcake.com'
// axios.defaults.baseURL = 'http://181cnapp.juhaowu.cn'
axios.defaults.baseURL = 'https://www.juhaowu.cn/'
    // axios.defaults.timeout = 5000;
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';

//POST传参序列化
axios.interceptors.request.use((config) => {
    config.headers['gtoken'] = "taiwan"
  return config;
}, (error) => {
  // _.toast("错误的传参", 'fail');
  return Promise.reject(error);
});

//返回状态判断
// axios.interceptors.response.use((res) => {
//   if (!res.data.success) {
//     // _.toast(res.data.msg);
//     return Promise.reject(res);
//   }
//   return res;
// }, (error) => {
//   // _.toast("网络异常", 'fail');
//   return Promise.reject(error);
// });

export function fetch(url, params) {
    return new Promise((resolve, reject) => {
        axios.post(url, params)
            .then(response => {
                resolve(response.data);
            }, err => {
                reject(err);
            })
            .catch((error) => {
                reject(error)
            })
    })
}

export default {
    POST(url, params) {
        return fetch(url, params);
    },
    // post(url, params) {
    //     return fetch(url, params);
    // }
}



// WEBPACK FOOTER //
// ./src/components/api.js